export function formatInstant(instant: unknown): string {
  return new Date(String(instant)).toLocaleString();
}

export function formatInstantDate(instant: unknown): string {
  return new Date(String(instant)).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export function formatInstantTime(instant: unknown): string {
  return new Date(String(instant)).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function initials(name: string | null | undefined, fallback = '?'): string {
  const source = (name ?? '').trim();
  if (!source) {
    return fallback;
  }

  return (
    source
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part[0]?.toUpperCase() ?? '')
      .join('') || fallback
  );
}
